module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-plan"
  }, [(_vm.$is('plan-data')) ? _c('div', {
    staticClass: "plan-data"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('strong', [_vm._v("Plan Details")]), _c('h2', [_vm._v(_vm._s(_vm.item.name))]), _c('p', [_vm._v(_vm._s(_vm.item.descriptions))])]), _c('div', {
    staticClass: "columns"
  }, [_c('strong', [_vm._v("Duration")]), _c('h3', [_vm._v(_vm._s(_vm.item.duration) + " Days")])]), _vm._m(0), _vm._m(1)])]) : _vm._e(), (_vm.$is('listing')) ? _c('div', {
    staticClass: "plan-list"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card4', {
    attrs: {
      "showAction": true
    }
  }, [_c('div', {
    staticClass: "field-plan-name",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "field-booking-mode",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.booking_mode))])]), _c('div', {
    staticClass: "field-plan-cost",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.cost))])]), _c('div', {
    staticClass: "field-plan-status",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'plan',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('span', [_c('strong', [_vm._v("Min Driving Price")]), _c('h3', [_vm._v("--")])]), _c('span', [_c('strong', [_vm._v("Max Driving Price")]), _c('h3', [_vm._v("--")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('span', [_c('strong', [_vm._v("Min Reserv. Price")]), _c('h3', [_vm._v("--")])]), _c('span', [_c('strong', [_vm._v("Max Reserv. Price")]), _c('h3', [_vm._v("--")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16d7bc20!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Plan.vue
// module id = 2291
// module chunks = 1